import { render, staticRenderFns } from "./indexMainLeft.vue?vue&type=template&id=61637247&scoped=true&"
import script from "./indexMainLeft.vue?vue&type=script&lang=js&"
export * from "./indexMainLeft.vue?vue&type=script&lang=js&"
import style0 from "./indexMainLeft.vue?vue&type=style&index=0&id=61637247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61637247",
  null
  
)

export default component.exports